exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.estilo_jep[data-v-9caf22f8] {\n  background-color: #0b121f;\n}\n", ""]);

// exports
